window.BundleStore = (() => {
	const KEY = 'Bundle2025';
	let config,
		state = {},
		handleState,
		saveTimer,
		uiTimer;
	const clone = window.structuredClone || ((o) => JSON.parse(JSON.stringify(o)));
	const num = (v) => +v || 0;
	const storage = {
		get: () => {
			try {
				let d = JSON.parse(localStorage.getItem(KEY));
				return d && typeof d === 'object' && !Array.isArray(d) ? d : {};
			} catch {
				return {};
			}
		},
		set: (d) => localStorage.setItem(KEY, JSON.stringify(d)),
	};
	const save = () => {
		clearTimeout(saveTimer);
		saveTimer = setTimeout(() => storage.set(state), 50);
	};
	const getConfig = () => config;
	const getStep = (s) => config.steps[s];
	const qtyStep = (s) => (handleState[s] || []).length;
	const findItem = (s, id) => handleState[s]?.find((i) => i.id == id);
	const currentHandle = () => location.pathname.split('/').filter(Boolean).pop();
	function init(cfg) {
		let handle = currentHandle();
		config = cfg.find((c) => c.handle === handle);
		if (!config) return console.warn('Bundle config not found:', handle);
		state = storage.get();
		const oldHandleState = state[config.handle] || {};
		handleState = state[config.handle] = syncHandleState(config, oldHandleState);
		save();
		fire('init', { notice: false });
	}
	function add(step, item, q = 1) {
		let stepCfg = getStep(step);
		if (!stepCfg?.items?.includes(item.id)) return;

		let inc = Math.max(1, num(q) || 1);
		let found = findItem(step, item.id);

		if (found) {
			found.quantity += inc;
			save();
			fire('add', { step, item: found, quantity: inc });
			return;
		}

		if (qtyStep(step) >= stepCfg.max) return;

		const nextItem = { ...item, quantity: inc };
		handleState[step].push(nextItem);
		save();
		fire('add', { step, item: nextItem, quantity: inc });
	}
	function update(step, id, qty) {
		let item = findItem(step, id);
		if (!item) return;
		qty = num(qty);
		if (qty <= 0) return remove(step, id);

		item.quantity = qty;
		save();
		fire('update', { step, item });
	}
	function remove(step, id) {
		handleState[step] = handleState[step].filter((i) => i.id != id);
		save();
		fire('remove', { step, id });
	}
	function clear() {
		handleState = state[config.handle] = {};
		Object.keys(config.steps).forEach((s) => (handleState[s] = []));
		save();
		fire('clear', { notice: false });
	}
	const getByHandle = () => Object.values(handleState).flat();
	const validate = (step) => {
		let cfg = getStep(step);
		let total = qtyStep(step);
		return { total, valid: total >= cfg.min && total <= cfg.max, hit: total >= cfg.max };
	};
	const validateAll = () => Object.keys(config.steps).every((s) => validate(s).valid);
	const tierData = (q) => config.tiers.reduce((a, t) => (q >= t.quantity ? t : a), { quantity: 0, discount: 0 });
	const totals = () => {
		let totalQty = getByHandle().length;
		let totalUnits = 0,
			price = 0;

		for (let { quantity, price: p } of getByHandle()) {
			totalUnits += quantity;
			price += quantity * p;
		}

		let tier = tierData(totalQty);
		let discount = price * tier.discount * 0.01;

		return {
			totalQty,
			totalUnits,
			totalPrice: price,
			discount,
			finalPrice: price - discount,
			tier,
		};
	};
	const fire = (action, meta = {}) => {
		clearTimeout(uiTimer);
		const detail = { action, state: clone(state), totals: totals(), ...meta };
		uiTimer = setTimeout(updateUI);
		renderCart({ option: detail });
		document.dispatchEvent(new CustomEvent('bundle:' + action, { detail }));
	};
	const loadCart = () => {
		const params = new URLSearchParams(location.search);
		const cart = params.get('cart');
		if (!cart) return;
		const skuMap = new Map([...document.querySelectorAll('.Bundle2025-product-item')].map((el) => [el.dataset.sku?.toUpperCase(), el]));
		clear();
		const action = 'loadCart';
		let detail = { action, items: [] };
		cart.split(',').forEach((s) => {
			const [sku, q] = s.split('_');
			const el = skuMap.get(sku?.toUpperCase());
			if (!el) return;
			const step = el.closest('[data-step]')?.dataset.step;
			const item = $(el).data('item');
			if (step && item) {
				detail.items.push(item);
				add(step, item, +q || 1);
			}
		});
		params.delete('cart');
		const newUrl = location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash;
		history.replaceState({}, '', newUrl);
		document.dispatchEvent(new CustomEvent('bundle:' + action, { detail }));
	};
	const toggle = (el, on) => el?.toggleAttribute('disabled', on);
	const updateUI = () => {
		let selected = getByHandle();
		let map = new Map(selected.map((i) => [i.id, i]));
		let qty = selected.length;
		document.querySelectorAll('.Bundle2025-progress-bar').forEach((b) => b?.style.setProperty('--currentValue', qty));
		for (let step in config.steps) {
			let stepState = validate(step);
			document.querySelectorAll(`.option-step[data-step="${step}"] .Bundle2025-product-item,.Bundle2025-popup-product-detail[data-step="${step}"]`).forEach((el) => {
				let id = +el.dataset.id;
				let item = map.get(id);
				let btnAdd = el.querySelector('.btn-addtobundle');
				let btnPlus = el.querySelector('.is--plus');
				let btnMinus = el.querySelector('.is--minus');
				let input = el.querySelector('.Bundle2025-quantity-input');
				el.classList.toggle('is-selected', !!item);
				toggle(btnAdd, stepState.hit);
				toggle(btnPlus, stepState.hit || !item);
				if (input) {
					let q = item ? item.quantity : 0;
					input.value = q || 1;
					input.setAttribute('value', q);
					btnMinus?.classList.toggle('is--delete', q <= 1);
				}
			});
			document.querySelector(`.cart-step[data-step="${step}"] .step-required`)?.classList.toggle('alert', !stepState.valid);
		}
	};
	const cartItemTemplate = (item, stepState) => {
		const title = decodeHTML(item.name);
		if (!item) return;
		return `<div class="Bundle2025-cart-item" data-id="${item.id}"><div class="Bundle2025-cart-item-wrapper ${item.image ? 'has-image' : 'no-image'}"><div class="Bundle2025-cart-item-delete delete"></div><img src="${item.image}" alt="${title}" loading="eager" decoding="async"/><div class="Bundle2025-product-info"><div class="product-title">${title}</div><div class="t4s-product-price"><ins class="text-evergreen_green">${formatCC(item.price)}</ins></div><div class="Bundle2025-quantity"><button type="button" class="Bundle2025-quantity-selector is--minus ${item.quantity <= 1 ? 'is--delete' : ''}"><svg aria-hidden=true class="icon icon--minus"viewBox="0 0 10 2"role=presentation><path d="M10 0v2H0V0z"fill=currentColor></path></svg> <svg aria-hidden=true class="icon icon--delete"viewBox="0 0 24 24"fill=none stroke=currentColor stroke-linecap=round stroke-linejoin=round width=17><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1=10 x2=10 y1=11 y2=17></line><line x1=14 x2=14 y1=11 y2=17></line></svg></button><input readonly type="number" class="Bundle2025-quantity-input" value="${item.quantity}"><button type="button" class="Bundle2025-quantity-selector is--plus" ${stepState.hit ? 'disabled' : ''}><svg aria-hidden=true class="icon icon--plus"viewBox="0 0 10 10"role=presentation focusable=false><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z"fill=currentColor fill-rule=evenodd></path></svg> <svg aria-hidden=true class="icon icon--disabled"viewBox="0 0 100 100"><circle cx=50 cy=50 fill=none r=40 stroke=red stroke-width=8></circle><line x1=20 x2=80 y1=20 y2=80 stroke=red stroke-width=8></line></svg></button></div></div></div></div>`;
	};
	const cartItemBlank = () => {
		return `<div class="Bundle2025-cart-item-blank"><a class="progress-summary-toggle-class tamixScrollTo" href="#step_Adult_Health"><span class="blank-tag"></span> <span class="text">Add items to save more</span></a></div>`;
	};
	const updateCartRows = (container, items, stepState) => {
		items.forEach((item) => {
			const row = container.querySelector(`.Bundle2025-cart-item[data-id="${item.id}"]`);
			if (!row) return;

			const input = row.querySelector('.Bundle2025-quantity-input');
			const minus = row.querySelector('.is--minus');
			const plus = row.querySelector('.is--plus');
			const title = row.querySelector('.product-title');
			const price = row.querySelector('.t4s-product-price ins');

			if (input) {
				input.value = item.quantity;
				input.setAttribute('value', item.quantity);
			}

			minus?.classList.toggle('is--delete', item.quantity <= 1);

			if (plus) {
				plus.toggleAttribute('disabled', stepState.hit);
			}

			if (title) title.textContent = decodeHTML(item.name);
			if (price) price.textContent = formatCC(item.price);
		});
	};
	const decodeHTML = (str) => {
		const txt = document.createElement('textarea');
		txt.innerHTML = str || '';
		return txt.value;
	};
	const getCartRenderKey = (items, stepState) => {
		return [items.map((i) => i.id).join(','), stepState.hit ? 'hit' : 'not-hit'].join('|');
	};

	const renderCart = ({ option }) => {
		const cart = document.querySelector('.Bundle2025-cart');
		if (!cart) return;

		for (const step in handleState) {
			const container = cart.querySelector(`.cart-step[data-step="${step}"] .step-cart-items`);
			if (!container) continue;

			const items = handleState[step];
			const stepState = validate(step);
			const renderKey = getCartRenderKey(items, stepState);

			if (container.dataset.renderKey !== renderKey) {
				let html = items.map((it) => cartItemTemplate(it, stepState)).join('');

				if (!stepState.hit) {
					html += cartItemBlank();
				}

				container.innerHTML = html;
				container.dataset.renderKey = renderKey;
			} else {
				updateCartRows(container, items, stepState);
			}

			document.querySelectorAll(`.block-step-status [data-step="${step}"]`).forEach((b) => {
				b.classList.toggle('active', stepState.valid);
			});
		}

		const { totalQty, totalPrice, discount, finalPrice, tier } = totals();

		bundleNotice(totalQty, option.notice ?? true);

		cart.querySelectorAll('[data-countItem]').forEach((el) => (el.textContent = totalQty));
		cart.querySelectorAll('[data-nameDiscount]').forEach((el) => (el.textContent = tier?.name ? `(${tier.name})` : ''));
		cart.querySelectorAll('[data-totalDiscount]').forEach((el) => (el.textContent = discount ? `-${tier.discount}%` : '-'));
		cart.querySelectorAll('[data-totalPrice]').forEach((el) => (el.textContent = totalPrice > finalPrice ? formatCC(totalPrice) : ''));
		cart.querySelectorAll('[data-totalValue]').forEach((el) => (el.textContent = formatCC(finalPrice)));

		toggle(document.querySelector('.Bundle2025-cart-submit'), !validateAll());
	};
	let noticeEl, noticeContentEl, headingEls, tierSteps;
	const bundleNotice = (q, show = true) => {
		noticeEl ||= document.querySelector('.Bundle2025-notification');
		noticeContentEl ||= noticeEl?.querySelector('.Bundle2025-notification-content');
		headingEls ||= document.querySelectorAll('.Bundle2025-Option-Main .progress-heading');
		if (!noticeEl || !noticeContentEl) return;
		if (!tierSteps) {
			tierSteps = [...document.querySelectorAll('.Bundle2025-cart .progress-bar-step')]
				.map((s) => ({ q: +s.dataset.quantity, d: +s.dataset.discount }))
				.filter((s) => Number.isFinite(s.q) && Number.isFinite(s.d) && s.q > 0 && s.d > 0)
				.sort((a, b) => a.q - b.q);
		}
		if (!tierSteps.length) return;
		const last = tierSteps.at(-1);
		let cur = { q: 0, d: 0 };
		for (const s of tierSteps) {
			if (q >= s.q) cur = s;
		}
		let msg, msg2;
		if (q >= last.q) {
			msg = `${cur.d}% off unlocked!`;
			msg2 = msg;
		} else {
			const r = last.q - q;
			const next = `Add ${r} more item${r !== 1 ? 's' : ''} to save ${last.d}%`;
			msg2 = next;
			msg = `${cur.d ? `${cur.d}% off unlocked. ` : ''}${next}`;
		}
		if (!msg) return;
		headingEls.forEach((el) => (el.textContent = msg2));
		if (!show) return;
		noticeContentEl.textContent = msg;
		noticeEl.classList.add('open');
		clearTimeout(noticeEl._timer);
		noticeEl._timer = setTimeout(() => noticeEl.classList.remove('open'), 3000);
	};
	const PopupCache = new Map();
	const getPopupHTML = (url, id) =>
		PopupCache.has(url)
			? Promise.resolve(PopupCache.get(url))
			: new Promise((resolve) => {
					NuBestCart.section(id.toLowerCase(), {
						url,
						done: (sections) => {
							let html = $(sections).find(`#${id}`)[0]?.outerHTML || '';
							PopupCache.set(url, html);
							resolve(html);
						},
					});
				});
	async function openPopup($btn, popup = 'Bundle2025-popup-product-detail') {
		let id = $btn.closest('[data-id]').data('id');
		let step = $btn.closest('[data-step]').data('step');
		let url = $btn.attr('href').split('?')[0];
		let product = $btn.closest('.Bundle2025-product-item');
		let actionHTML = product.find('.bundle-action')[0].outerHTML;
		$('#' + popup).remove();
		let html = await getPopupHTML(url, popup);
		let $popup = $(html);
		$popup.data({ id, step }).attr({ 'data-id': id, 'data-step': step }).toggleClass('is-selected', product.hasClass('is-selected'));
		$popup.find('.bundle-action').replaceWith(actionHTML);
		$('body').append($popup);
		$popup.find('.flickityt4s').each(function () {
			this.flickityt4s = this.flickityt4s || new T4SThemeSP.Carousel(this);
		});
		requestAnimationFrame(() => $(window).trigger('resize'));
		setTimeout(() => T4SThemeSP.Drawer.opend($('#' + popup)), 100);
	}
	const allowedItemSet = (stepCfg) => new Set((stepCfg?.items || []).map(Number));
	function syncStepState(stepKey, items, stepCfg) {
		const allowed = allowedItemSet(stepCfg);
		const max = +stepCfg?.max || 0;
		if (!Array.isArray(items)) items = [];
		let cleaned = items
			.filter((it) => it && allowed.has(+it.id))
			.map((it) => ({
				...it,
				id: +it.id,
				quantity: Math.max(1, +it.quantity || 1),
			}));
		const mergedMap = new Map();
		for (const it of cleaned) {
			const found = mergedMap.get(it.id);
			if (found) found.quantity += it.quantity;
			else mergedMap.set(it.id, { ...it });
		}
		let merged = [...mergedMap.values()];
		let total = merged.reduce((sum, it) => sum + it.quantity, 0);
		if (total > max) {
			let over = total - max;
			for (let i = merged.length - 1; i >= 0 && over > 0; i--) {
				const reducible = Math.min(merged[i].quantity, over);
				merged[i].quantity -= reducible;
				over -= reducible;
			}
			merged = merged.filter((it) => it.quantity > 0);
		}
		return merged;
	}
	function syncHandleState(bundleConfig, oldHandleState = {}) {
		const next = {};
		for (const stepKey of Object.keys(bundleConfig.steps || {})) {
			next[stepKey] = syncStepState(stepKey, oldHandleState[stepKey] || [], bundleConfig.steps[stepKey]);
		}
		return next;
	}
	return {
		init,
		add,
		update,
		remove,
		getByHandle,
		validate,
		totals,
		clear,
		loadCart,
		openPopup,
		currentHandle,
		getConfig,
	};
})();
$(document).ready(() => {
	const configEl = document.getElementById('BundleStoreConfig');
	const BundleConfig = configEl ? JSON.parse(configEl.textContent) : [];
	BundleStore.init(BundleConfig);
	$(document)
		.on('bundle:init', function ({ detail }) {
			console.log(detail.action, detail);
		})
		.on('bundle:add', function ({ detail }) {
			console.log(detail.action, detail);
		})
		.on('bundle:update', function ({ detail }) {
			console.log(detail.action, detail);
		})
		.on('bundle:remove', function ({ detail }) {
			console.log(detail.action, detail);
		})
		.on('bundle:clear', function ({ detail }) {
			console.log(detail.action, detail);
		})
		.on('bundle:loadCart', function ({ detail }) {
			console.log(detail.action, detail);
			if (window.width < 992) {
				$('.Bundle2025-cart .progress-summary-toggle-class').trigger('click');
			}
		})
		.on('click', '.btn-addtobundle', function () {
			const id = $(this).closest('[data-id]').data('id');
			const step = $(this).closest('[data-step]').data('step');
			const item = $(`.Bundle2025-product-item[data-id="${id}"]`).data('item');
			BundleStore.add(step, item);
		})
		.on('click', '.Bundle2025-cart-item-delete,.is--delete', function () {
			const id = $(this).closest('[data-id]').data('id');
			const step = $(this).closest('[data-step]').data('step');
			BundleStore.remove(step, id);
		})
		.on('click', '.Bundle2025-quantity-selector', function () {
			const input = $(this).siblings('input');
			let qty = +input.val();
			if ($(this).hasClass('is--minus') && qty > 1) qty--;
			if ($(this).hasClass('is--plus')) qty++;
			input.val(qty).trigger('change');
		})
		.on('change', '.Bundle2025-quantity-input', function () {
			const id = $(this).closest('[data-id]').data('id');
			const step = $(this).closest('[data-step]').data('step');
			BundleStore.update(step, id, this.value);
		})
		.on('click', '.Bundle2025-notification', function (event) {
			$(this).removeClass('open');
		})
		.on('click', '.btn-bundle2025-popup-product-detail', function (e) {
			e.preventDefault();
			BundleStore.openPopup($(this));
		})
		.on('click', '.Bundle2025-cart-submit', async function (event) {
			const $btn = $(this);
			$btn.addClass('is--loading');
			try {
				const config = BundleStore.getConfig();
				const property = { key: new Date().getTime(), id: config.id, bundle: config.name };
				const items = BundleStore.getByHandle().map(({ id, name, sku, handle, price, quantity }) => ({
					id,
					quantity,
					properties: {
						_nubest_bundle: JSON.stringify({ ...property, name, sku, handle, quantity, price }),
						_my_boost_type: 'Bundle Builder',
					},
				}));
				console.log('Add Bundle', items);
				NuBestCart.add(items, {
					done: (res) => {
						BundleStore.clear();
				    $btn.removeClass('is--loading');
					},
				});
			} catch (err) {
				console.error('Bundle submit failed:', err);
				$btn.removeClass('is--loading');
			}
		});
	BundleStore.loadCart();
});
